module.exports = __webpack_public_path__ + "static/media/tickets.8e9f21a8.svg";